define.alias("shared/components/shared/wizards/carousel/step-three", "media/components/shared/wizards/carousel/step-three");